import { LoginPageForm } from '../components/Auth-Designer/LoginPageForm';

const LoginPage = () => {
  return (
    <main>
      <LoginPageForm />
    </main>
  );
};

export default LoginPage;